import API from '@/api'
import * as types from './mutation-types'

const namespaced = true

const initialState = {
  list: []
}

const mutations = {
  [types.PUT_PAGES] (state, pages) {
    state.list = pages
  }
}

const actions = {
  list: ({ commit }) => (
    API.get('pages/').then((data) => {
      commit(types.PUT_PAGES, data)
      return data
    })
  )
}

const getters = {
  list (state) {
    return state.list
  }
}

export default {
  namespaced,
  state: initialState,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/modules/pages.js